var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-idle"},[_c('div',[_vm._v("Even geduld...")])])
}]

export { render, staticRenderFns }